<template>
  <form novalidate @submit.prevent="onAccept">
    <LsModal title="Updated Terms of Service" track-id="terms_of_service_modal" :cancelable="false">
      <template #body>
        <TOSModalText />
      </template>
      <template #footer>
        <LsButton
          type="submit"
          text="Accept"
          track-id="terms_of_service_modal-accept"
          :loading="termsOfService.loadingStatus.isUpdating"
        />
      </template>
    </LsModal>
  </form>
</template>

<script>
import { LsModal, LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { TERMS_OF_SERVICE__ACCEPT } from '@/store/types';
import TOSModalText from './components/TOSModalText.vue';

export default {
  name: 'TOSModal',
  components: {
    LsModal,
    LsButton,
    TOSModalText,
  },
  computed: {
    ...mapState(['termsOfService']),
  },
  methods: {
    ...mapActions([TERMS_OF_SERVICE__ACCEPT]),
    async onAccept() {
      this[TERMS_OF_SERVICE__ACCEPT]({ onSuccess: this.onSuccess });
    },
    onSuccess() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
